var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ku-article-timeline"},[_c('div',{staticClass:"ku-timeline-item"},_vm._l((_vm.list),function(item){return _c('div',{key:item.imageUrl,staticClass:"ku-timeline-img"},[_c('img',{attrs:{"src":item.imageUrl}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }